<template>
    <div class="handle-transfer">

        <pageheader :text="title"/>

        <div v-if="success == null">

            <div class="text-center  my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Laster...</strong>
            </div>

        </div>

        <div v-else-if="success == true">
            <p>
                Din betaling er fullført og poengene satt på konto
            </p>

            <p>
                Du kan se transaksjonen i <router-link to="/transaksjoner">oversikten.</router-link>
            </p>

        </div>

        <div v-else>
            <p>
                Din betaling ble ikke gjennomført på grunn av en feil.
            </p>

            <p>
                Venligst sjekk saldo på konto og <router-link to="/overforing">prøv igjen.</router-link>
            </p>

            <p>
                Ta evt. kontakt med oss hvis du da ikke får det til.
            </p>
        </div>


    </div>
</template>

<script>
// @ is an alias to /src


export default {
    name: 'HandleTransfer',
    components: {

    },
    data() {
        return {
            transactionId: '',
            success: null,
            title: 'Behandler...'
        }
    },
    mounted() {
        let route = this.$router.currentRoute;
        let transactionId = route.query.transactionId;


        // Capture payment
        this.$api.patch(`/users/${this.$store.getUser().card_id}/payments/${transactionId}/`, {})
        .then((response) => {

            console.log(response);

            this.success = true
            this.title = "Din betaling gikk igjennom"

        })
        .catch((response) => {
            console.log(response);

            // Display error
            this.success = false
            this.title = "En feil har oppstått"
        });



    },
    methods: {

    }
}
</script>


<style lang="scss">

    .transferAmount {
        font-size: 1.5em;
        margin-right: 0.5em;
    }
    .errors {
        font-size: 0.8em;
        margin-top: 2em;
    }

</style>
